import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

export const dashboardTeacher: ApiFunc<`${typeof API.DASHBOARD_TEACHER}`, 'get'> = data =>
  getInstance().get(API.DASHBOARD_TEACHER, {
    params: data,
  })

